import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTestCentersByArea } from "../../actions/testcenterActions";

class TCForm extends Component {
  state = {
    zipcode: "",
    miles: "10",
    errors: {},
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { zipcode, miles } = this.state;

    // Check For Errors
    if (zipcode === "") {
      this.setState({ errors: { zipcode: "Zipcode is required" } });
      return;
    }

    // Get Test Centers
    this.props.getTestCentersByArea(zipcode, miles);

    // Clear State
    this.setState({
      zipcode: "",
      miles: "10",
      errors: {},
    });
  };
  onChange = (e) => this.setState({ [e.target.name]: e.target.value });
  render() {
    const { zipcode, miles, errors } = this.state;
    return (
      <form className="my-4" onSubmit={this.onSubmit}>
        <h4>Find Test Centers Near You</h4>
        <div className="form-group">
          <label htmlFor="zipcode">Near this location</label>
          <input
            type="number"
            name="zipcode"
            className={classnames("form-control form-control-lg", {
              "is-invalid": errors.zipcode,
            })}
            placeholder="Enter Zipcode"
            value={zipcode}
            onChange={this.onChange}
          />
          {errors.zipcode && (
            <div className="invalid-feedback">{errors.zipcode}</div>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="zipcode">Search Area</label>
          <select
            name="miles"
            value={miles}
            onChange={this.onChange}
            className={classnames("form-control form-control-lg", {
              "is-invalid": errors.miles,
            })}
          >
            <option value="1">1 mile</option>
            <option value="5">5 miles</option>
            <option value="10">10 miles</option>
            <option value="25">25 miles</option>
            <option value="50">50 miles</option>
          </select>
          {errors.miles && (
            <div className="invalid-feedback">{errors.miles}</div>
          )}
        </div>
        <input
          type="submit"
          value="Search For Test Center"
          className="btn btn-block btn-lg btn-dark"
        />
      </form>
    );
  }
}
TCForm.propTypes = {
  testcenters: PropTypes.array.isRequired,
  getTestCentersByArea: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  testcenters: state.testcenter.testcenters,
});

export default connect(mapStateToProps, {
  getTestCentersByArea,
})(TCForm);
